import React, { useState } from "react";

import { PdfDocument } from "../../components/PDF/CheckPdf";
import { PdfDocumentMashreq } from "../../components/PDF/CheckMashreq";
import { PDFDownloadLink } from "@react-pdf/renderer";
import axios from "axios";

import { get_cookies } from "../../components/Cookies/Cookies";
// Material UI Component
import Button from "@material-ui/core/Button";
import { TextField, Grid } from "@material-ui/core";

import { fetch_transaction_history } from "../../services/api_calls/table_fetch";
import { useEffect } from "react";
import { setDate } from "date-fns";
import { PdfDocumentEmirates } from "../../components/PDF/CheckEmirates";

const CheckPrint = ({ checkNo, branchidno, onFetchedApi }) => {
  const [posts, setPosts] = useState(false);
  const [open, setOpen] = useState(false);
  const [headerDetailsP, setHeaderDetailsP] = useState([]);
  const [itemDetailsP, setItemDetailsP] = useState([]);
  const [checkDetails, setCheckDetails] = useState([]);
  const [btnDisable, setBtnDisable] = useState(false);
  const useridNo = get_cookies("branchidno");

  useEffect(() => {
    setPosts((s) => {
      return s == undefined ? false : true;
    });
  }, []);

  const get_checkpdf = async (checkNo, branchidno, el) => {
    setBtnDisable(true);
    const formData = new FormData();
    formData.append("chkno", checkNo);
    formData.append("jc_u_idno", branchidno);
    await axios
      .post(process.env.REACT_APP_API_URL + "print_check", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setHeaderDetailsP(res.data.header_details);
        setItemDetailsP(res.data.item_details);
        setCheckDetails(res.data.check_details);
        setOpen(true);
        setTimeout(() => {
          el.getElementsByTagName("a")[0].click();
        }, 300);
        setTimeout(() => {
          onFetchedApi();
          setBtnDisable(false);
        }, 2600);
      })
      .catch((error) => {
        setBtnDisable(false);
        // console.log(error.message);
      });
    // setHeaderDetailsP(res.data.header_details);
    // setItemDetailsP(res.data.item_details);
    // setPaymentP(res.data.paymentDetails);
    // setComputationDetailsP(res.data.computations_details);
    // setHidePrint(true);
  };

  const handleDownload = (e) => {
    get_checkpdf(checkNo, branchidno, e.target);
  };

  return (
    <Grid item xs={12} sm={6} md={6} lg={12} xl={12}>
      {!posts ? (
        <Button variant="contained" color="primary">
          Loading document...
        </Button>
      ) : useridNo !== "ABUDHABIHQ" && useridNo !== "DUBAIHQ" ? (
        <Button
          variant="contained"
          color="primary"
          onClick={handleDownload}
          disabled={btnDisable}
        >
          Print
          <PDFDownloadLink
            document={
              open && (
                <PdfDocument
                  className="MuiButton-root"
                  headers={headerDetailsP}
                  items={itemDetailsP}
                />
              )
            }
            fileName={"check" + checkNo + ".pdf"}
          />
        </Button>
      ) : (
        useridNo !== "ABUDHABIHQ"?
         <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownload}
                  disabled={btnDisable}
                >
                  Print
                  <PDFDownloadLink
                    document={
                      open && (
                        <PdfDocumentEmirates
                          className="MuiButton-root"
                          headers={headerDetailsP}
                          items={itemDetailsP}
                        />
                      )
                    }
                    fileName={"check" + checkNo + ".pdf"}
                  />
                </Button>:

        // <Button
        //   variant="contained"
        //   color="primary"
        //   onClick={handleDownload}
        //   disabled={btnDisable}
        // >
        //   Print
        //   <PDFDownloadLink
        //     document={
        //       open && (
        //         <PdfDocumentMashreq
        //           className="MuiButton-root"
        //           headers={headerDetailsP}
        //           items={itemDetailsP}
        //         />
        //       )
        //     }
        //     fileName={"check" + checkNo + ".pdf"}
        //   />
        // </Button>:
                  <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownload}
                  disabled={btnDisable}
                >
                  Print
                  <PDFDownloadLink
                    document={
                      open && (
                        <PdfDocumentEmirates
                          className="MuiButton-root"
                          headers={headerDetailsP}
                          items={itemDetailsP}
                        />
                      )
                    }
                    fileName={"check" + checkNo + ".pdf"}
                  />
                </Button>
      )}
    </Grid>
  );
};

export default CheckPrint;
